@let elligibleWithoutError = isElligible() && !hasError();

<sd-title
  [titleThemesConfig]="BrandThemesEnum.brand"
  class="is-main"
  [titleLevel]="2"
  customClass="brand--h3 is-semi-bold"
>
  {{ referAFriend.title }}
</sd-title>

<sd-border-wrapper titleLevel="2">
  <div class="c___refer-friend">
    <sd-title customClass="is-main brand--h3">
      {{ referAFriend.headline }}
    </sd-title>
    <div class="c__refer-friend-description">
      <p class="is-bold is-subline">
        {{ referAFriend.subline }}<span class="is-subline-extra">{{ referAFriend.sublineExtra }}</span>
      </p>
      <sd-html innerClass="c__description" [html]="referAFriend.description" />
      @if (elligibleWithoutError) {
        <sd-html innerClass="c__description" [html]="referAFriend.eligibleDescription" />
      }
    </div>
    @if (!isElligible()) {
      <p class="is-bold">{{ referAFriend.notEligibleDescription }}</p>
    }
    <div class="c__todo-card-container">
      @if (completedOrderCard(); as completedOrder) {
        <sd-todo-card [todoCardData]="completedOrder" />
      }
      @if (optinCard()) {
        <sd-todo-card [todoCardData]="optinCard()" />
      }
      @if (elligibleWithoutError) {
        @if (referLink(); as link) {
          <div class="c__copy-refer-link-container">
            <span class="is-overline">{{ referAFriend.copyInstruction }}</span>
            <div class="c__copy-refer-link" [copyClipboard]="link" sdCopyToClipBoard (copied)="linkIsCopied($event)">
              <span> {{ link | truncate : 33 }} </span>
              @if (isCopied()) {
                <sd-icon name="icon-check" />
              } @else {
                <sd-icon name="icon-copy" />
              }
            </div>
          </div>
        }
      }
      @if (hasError()) {
        <div class="c__refer-friend-error">
          <sd-icon name="icon-info"/>
          <div class="c__error-info">
            <p class="c__error-title brand--h4">{{ referAFriend.error.title }}</p>
            <p class="c__error-description is-body-m">{{ referAFriend.error.message }}</p>
          </div>
        </div>
      }
    </div>
    <div class="c__refer-friend-help">
      <div class="c__help-title brand--h4 is-bold">
        <sd-icon name="icon-help"/><p class="brand--h4">{{ referAFriend.howItWorks.title }}</p>
      </div>
      <div class="c__help-list">
        @for (item of referAFriend.howItWorks.steps | sdParse; track item) {
          <p class="is-body-s">{{$index + 1 }}. {{ item }}</p>
        }
      </div>
    </div>
  </div>
</sd-border-wrapper>

@if (referAFriend.footnotePrimary || referAFriend.footnoteSecondary) {
  <div class="c__refer-friend-foot-note is-overline">
    <sd-html [html]="referAFriend.footnotePrimary" />
    <sd-html [html]="referAFriend.footnoteSecondary" />
  </div>
}

@if (isLoading()) {
  <div sd-loader></div>
}
